import * as yup from "yup";

export const CriarAcademicYearFormValidation =yup.object().shape({
    year: yup

        .number()
        .typeError("Deve ser numero")
        .required("O ano é obrigatório")
        .min(1990, "Só pode criar o próximo ano letivo")
        .max(new Date().getFullYear() + 1, "Só pode criar o próximo ano letivo")
    
})